module.exports = __webpack_public_path__ + "img/sii--icon.e13a0790.svg";